export default "__VITE_ASSET__52e6003f__"